import React, { useMemo, useState } from 'react';
import { Button } from '@mui/material';
import HttpClient from '../../../utils/HttpClient';
import { useEffect } from 'react';
import toast from 'react-hot-toast';

function FirstForm({ onNext, typeOfCompany, setTypeOfCompany }) {
    const [companyName, setcompanyName] = useState([])
    const [DesignationName, setDesignationName] = useState([])
    const [ProfileType, setProfileType] = useState([])
    const handleSubmit = (e) => {
        e.preventDefault();
        // console.log(typeOfCompany, "submit")
        // const values = Object.values(typeOfCompany);
        // if (values.includes("")) {
        //     toast.error("Empty Field detected");
        //     return; // Stop further execution
        // }
        const nameRegex = /^[a-zA-Z\s]+$/;
        const personName = typeOfCompany.personName.trim();
        if (!nameRegex.test(personName)) {
            toast.error("Invalid name. Please use only letters.");
            return;
        }
        onNext();
    };

    const handleChange = (e) => {
        const { name, value } = e.target
        setTypeOfCompany(prev => ({ ...prev, [name]: value }));
    }

    const companyType = async () => {
        try {
            const res1 = await HttpClient.requestData("view-companyType", "GET", {})
            const res2 = await HttpClient.requestData("view-designation", "GET", {})
            const res3 = await HttpClient.requestData("get-profile-type", "GET", {})
            if (res1 && res1?.status) {
                setcompanyName(res1?.data);
                setDesignationName(res2?.data);
                setProfileType(res3?.data)
            }
        }
        catch (error) {
            console.error("Error fetching data:", error);
        }
    }

    useEffect(() => {
        companyType()
    }, [])

    useEffect(() => {
        const nameOfComapny = companyName?.filter((item) => item?._id === typeOfCompany?.companyTypeID)
        setTypeOfCompany(prev => ({ ...prev, "companyTypeName": nameOfComapny?.[0]?.type }));
    }, [typeOfCompany?.companyTypeID, companyName])

    useEffect(() => {
        const usertypeName = ProfileType?.filter((item) => item?._id === typeOfCompany?.userType)
        setTypeOfCompany(prev => ({ ...prev, "userTypeName": usertypeName?.[0]?.name }));
    }, [typeOfCompany?.userType, ProfileType])

    const memoizedCompanyNames = useMemo(() => companyName, [companyName]);
    const memoizedDesignationNames = useMemo(() => DesignationName, [DesignationName])
    const memoizedProfileType = useMemo(() => ProfileType, [ProfileType])

    return (
        <form onSubmit={handleSubmit} className='mb-2'>
            {/* Your form fields for the first step */}
            <div className="row">

                <div className="col-md-12 mt-3 ">
                    <label htmlFor="formGroupExampleInput">Profile Type<span className="text-danger">&nbsp;*</span></label>
                    <select
                        className="form-control"
                        aria-label="Default select example"
                        name="userType"
                        // value={typeOfCompany.userType}
                        // value={typeOfCompany.companyName && typeOfCompany.companyTypeID ? "65ddc3d1d569c29c97f6082c" : "65df70ab31670c8a6a8c5d76"}
                        onChange={handleChange}
                    >
                        <option value={""} disabled>Select Category</option>
                        {memoizedProfileType.map((item, i) =>
                            <option key={i} value={item?._id}>{item?.name}</option>
                        )
                        }
                    </select>
                </div>

                <div className="col-md-12 mt-3 ">
                    <label htmlFor="formGroupExampleInput">Company Name<span className="text-danger">&nbsp;*</span></label>
                    <input
                        type="text"
                        className="form-control"
                        placeholder="Enter Company Name"
                        name="companyName"
                        value={typeOfCompany?.companyName}
                        onChange={handleChange}
                    />
                </div>

                <div className="col-md-12 mt-3 ">
                    <label htmlFor="formGroupExampleInput">Type of Company<span className="text-danger">&nbsp;*</span></label>
                    <select
                        className="form-control"
                        aria-label="Default select example"
                        name="companyTypeID"
                        value={typeOfCompany.companyTypeID}
                        onChange={handleChange}
                    >
                        <option value={""} disabled>Select Category</option>
                        {memoizedCompanyNames.map((item, i) =>
                            <option key={i} value={item?._id}>{item?.type}</option>
                        )
                        }
                    </select>
                </div>

                <div className="col-md-12 mt-3 ">
                    <div className='d-flex '>
                        <label htmlFor="formGroupExampleInput" className='mt-2'>Gender<span className="text-danger">&nbsp;*</span></label>
                        <input
                            className='mx-2'
                            type="checkbox"
                            name="gender"
                            value="Male"
                            checked={typeOfCompany.gender === "Male"}
                            onChange={handleChange}
                        />
                        <label htmlFor="formGroupExampleInput" className='mt-2'>Male<span className="text-danger">&nbsp;</span></label>
                        <input
                            className='mx-2'
                            type="checkbox"
                            name="gender"
                            value="Female"
                            checked={typeOfCompany.gender === 'Female'}
                            onChange={handleChange}
                        />
                        <label htmlFor="formGroupExampleInput" className='mt-2'>Female<span className="text-danger">&nbsp;</span></label>

                    </div>
                </div>

                <div className="col-md-12 mt-3 ">
                    <label htmlFor="formGroupExampleInput">Person Name<span className="text-danger">&nbsp;*</span></label>
                    <div className='d-flex '>
                        <input
                            type="text"
                            className="form-control"
                            placeholder="Enter Person's name"
                            name="personName"
                            value={typeOfCompany.personName}
                            onChange={handleChange}
                        />
                    </div>
                </div>

                <div className="col-md-12 mt-3 ">
                    <label htmlFor="formGroupExampleInput">Designation<span className="text-danger">&nbsp;*</span></label>
                    <select
                        className="form-control"
                        aria-label="Default select example"
                        name="designationID"
                        value={typeOfCompany.designationID}
                        onChange={handleChange}
                    >
                        <option value={""} disabled>Select Designation</option>
                        {memoizedDesignationNames.map((item, i) =>
                            <option key={i} value={item?._id}>{item?.designation}</option>
                        )
                        }
                    </select>
                </div>
            </div>

            <Button type="submit" variant="contained" color="primary" className='mt-2'>
                Next
            </Button>
        </form>
    );
}
export default FirstForm